import { MessageFragment } from '@/shared/types/types.generated';

export enum OperationType {
  DONE = 'DONE',
  THINKING = 'THINKING',
  ERROR = 'ERROR',
}

export type TAppsyncChatData = {
  event: {
    chat_id: string;
    operation_type: OperationType;
    chat_object: MessageFragment;
  };
};
